import { Button, FormField, PasswordInput } from '@beatq/ui';
import {
  PIN_MAX_LENGTH,
  appendPinDigit,
  deletePinDigit,
  pinIsComplete,
  sanitisePinInput,
} from './pinPadLogic.js';

const PAD_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'back', '0'] as const;

export function PinPad({
  id,
  value,
  onChange,
  disabled,
  label = 'PIN',
}: {
  id: string;
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <div className="m10-pin-pad" data-testid="merchant-pin-pad">
      <FormField label={label} htmlFor={id} required>
        <PasswordInput
          id={id}
          inputMode="numeric"
          autoComplete="one-time-code"
          value={value}
          maxLength={PIN_MAX_LENGTH}
          disabled={disabled}
          onChange={(e) => onChange(sanitisePinInput(e.target.value))}
          className="m10-pin-pad-input text-h2 tracking-[0.35em]"
          aria-describedby={`${id}-hint`}
        />
      </FormField>
      <p id={`${id}-hint`} className="mer-field-hint m-0">
        {pinIsComplete(value) ? 'PIN entered' : 'Enter 4 to 6 digits. Paste is allowed.'}
      </p>
      <div className="m10-pin-pad-grid" role="group" aria-label="PIN pad">
        {PAD_KEYS.map((key) =>
          key === 'back' ? (
            <Button
              key="back"
              type="button"
              variant="secondary"
              className="m10-pin-pad-key"
              disabled={disabled || value.length === 0}
              aria-label="Delete last digit"
              onClick={() => onChange(deletePinDigit(value))}
            >
              ⌫
            </Button>
          ) : (
            <Button
              key={key}
              type="button"
              variant="secondary"
              className="m10-pin-pad-key"
              disabled={disabled || value.length >= PIN_MAX_LENGTH}
              aria-label={`Digit ${key}`}
              onClick={() => onChange(appendPinDigit(value, key))}
            >
              {key}
            </Button>
          ),
        )}
      </div>
    </div>
  );
}
